import { catchError, delay, EMPTY, skipWhile, switchMap, take } from 'rxjs'

import { logAndCaptureException } from '../../utils/errorTools'
import { userClaimIds } from '../../utils/userClaims'
import { decodeTokenCustomerId } from '../auth/scope'
import { latestAuthStateWithAccessToken$ } from '../auth/state'
import { deleteState, persistence } from './state/persistence'
import { getActiveOnboarding } from './utils'

const deleteStateByClaim = {
  [userClaimIds.onboardPatient]: deleteState(persistence.patientApiUrl),
  [userClaimIds.onboardPractitioner]: deleteState(persistence.practitionerApiUrl),
  [userClaimIds.onboardStudent]: deleteState(persistence.studentApiUrl),
}

export const onboardingCleanup$ = latestAuthStateWithAccessToken$.pipe(
  skipWhile(
    (authState) => !authState.isAuthenticated || !decodeTokenCustomerId(authState.accessToken),
  ),
  take(1),
  delay(1000), // Delay to reduce processing time on initial load
  switchMap((authState) => {
    if (!authState.isAuthenticated) return EMPTY

    const { accessToken, user } = authState
    const activeOnboarding = getActiveOnboarding(user)

    if (!activeOnboarding?.id) {
      return EMPTY
    }

    return deleteStateByClaim[activeOnboarding.id]({ token: accessToken })
  }),
  catchError((error) => {
    logAndCaptureException(error)
    return EMPTY
  }),
)
